'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _simpleAjax = require('simple-ajax');

var _simpleAjax2 = _interopRequireDefault(_simpleAjax);

var _Container = require('../containers/Container');

var _Container2 = _interopRequireDefault(_Container);

var _DefaultLink = require('./DefaultLink');

var _DefaultLink2 = _interopRequireDefault(_DefaultLink);

var _internal = require('../reducers/internal');

var _internal2 = _interopRequireDefault(_internal);

var _content = require('../actions/content');

var _emitters = require('../actions/emitters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/components/MetisMenu.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: H.Alper Tuna <halpertuna@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 16.09.2016
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/* eslint react/forbid-prop-types: [ "error", { forbid: [ "any", "array" ] } ] */

var lastReduxUid = -1;

var MetisMenu = function (_React$Component) {
  _inherits(MetisMenu, _React$Component);

  function MetisMenu(props) {
    _classCallCheck(this, MetisMenu);

    var _this = _possibleConstructorReturn(this, (MetisMenu.__proto__ || Object.getPrototypeOf(MetisMenu)).call(this, props));

    lastReduxUid += 1;
    _this.reduxUid = lastReduxUid;
    _this.useExternalReduxStore = props.useExternalReduxStore;
    _this.reduxStoreName = props.reduxStoreName;
    if (_this.useExternalReduxStore) {
      _this.store = _this.useExternalReduxStore;
    } else {
      _this.store = (0, _redux.createStore)(_internal2.default);
    }

    if (props.onSelected) {
      _this.store.dispatch((0, _emitters.updateListener)(_this.reduxUid, props.onSelected));
    }

    _this.LinkComponent = props.LinkComponent;

    if (props.content) {
      _this.updateContent(props.content);
      _this.updateActiveLink(props);
    } else if (props.ajax) {
      _this.updateRemoteContent(props);
    }

    _this.classStore = {
      classMainWrapper: (0, _classnames2.default)({ metismenu: !props.noBuiltInClassNames }, props.className),
      classContainer: typeof props.classNameContainer === 'function' ? props.classNameContainer : (0, _classnames2.default)({ 'metismenu-container': !props.noBuiltInClassNames }, props.classNameContainer),
      classContainerVisible: (0, _classnames2.default)({ visible: !props.noBuiltInClassNames }, props.classNameContainerVisible),
      classItem: (0, _classnames2.default)({ 'metismenu-item': !props.noBuiltInClassNames }, props.classNameItem),
      classLink: (0, _classnames2.default)({ 'metismenu-link': !props.noBuiltInClassNames }, props.classNameLink),
      classItemActive: props.classNameItemActive,
      classItemHasActiveChild: props.classNameItemHasActiveChild,
      classItemHasVisibleChild: props.classNameItemHasVisibleChild,
      classLinkActive: (0, _classnames2.default)({ active: !props.noBuiltInClassNames }, props.classNameLinkActive),
      classLinkHasActiveChild: (0, _classnames2.default)({ 'has-active-child': !props.noBuiltInClassNames }, props.classNameLinkHasActiveChild),
      classIcon: (0, _classnames2.default)({ 'metismenu-icon': !props.noBuiltInClassNames }, props.classNameIcon),
      classStateIcon: (0, _classnames2.default)({ 'metismenu-state-icon': !props.noBuiltInClassNames }, props.classNameStateIcon),

      iconNamePrefix: props.iconNamePrefix,
      iconNameStateHidden: props.iconNameStateHidden,
      iconNameStateVisible: props.iconNameStateVisible
    };
    return _this;
  }

  _createClass(MetisMenu, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        classStore: this.classStore,
        LinkComponent: this.LinkComponent
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.content !== nextProps.content) {
        this.updateContent(nextProps.content);
      }

      if (this.props.ajax !== nextProps.ajax) {
        this.updateRemoteContent(nextProps);
      } else if (this.props.activeLinkId !== nextProps.activeLinkId || this.props.activeLinkTo !== nextProps.activeLinkTo || this.props.activeLinkLabel !== nextProps.activeLinkLabel || this.props.activeLinkFromLocation !== nextProps.activeLinkFromLocation) {
        this.updateActiveLink(nextProps);
      }
    }
  }, {
    key: 'changeActiveLinkId',
    value: function changeActiveLinkId(value) {
      this.store.dispatch((0, _content.changeActiveLinkId)(this.reduxUid, value));
    }
  }, {
    key: 'changeActiveLinkTo',
    value: function changeActiveLinkTo(value) {
      this.store.dispatch((0, _content.changeActiveLinkTo)(this.reduxUid, value));
    }
  }, {
    key: 'changeActiveLinkLabel',
    value: function changeActiveLinkLabel(value) {
      this.store.dispatch((0, _content.changeActiveLinkLabel)(this.reduxUid, value));
    }
  }, {
    key: 'changeActiveLinkFromLocation',
    value: function changeActiveLinkFromLocation() {
      this.store.dispatch((0, _content.changeActiveLinkFromLocation)(this.reduxUid));
    }
  }, {
    key: 'updateActiveLink',
    value: function updateActiveLink(props) {
      if (props.activeLinkId) this.changeActiveLinkId(props.activeLinkId);else if (props.activeLinkTo) this.changeActiveLinkTo(props.activeLinkTo);else if (props.activeLinkLabel) this.changeActiveLinkLabel(props.activeLinkLabel);else if (props.activeLinkFromLocation) this.changeActiveLinkFromLocation();
    }
  }, {
    key: 'updateRemoteContent',
    value: function updateRemoteContent(props) {
      var _this2 = this;

      var ajax = new _simpleAjax2.default(props.ajax);
      ajax.on('success', function (event) {
        var content = void 0;
        var responseText = event.target.responseText.target.responseText;

        try {
          content = JSON.parse(responseText);
        } catch (e) {
          throw new Error('MetisMenu: Ajax response expected to be json, but got; ' + responseText);
        }
        _this2.updateContent(content);
        _this2.updateActiveLink(props);
      });
      ajax.send();
    }
  }, {
    key: 'updateContent',
    value: function updateContent(content) {
      this.store.dispatch((0, _content.updateContent)(this.reduxUid, content));
    }
  }, {
    key: 'render',
    value: function render() {
      var mainWrapper = _react2.default.createElement(
        'div',
        { className: this.classStore.classMainWrapper },
        _react2.default.createElement(_Container2.default, {
          reduxStoreName: this.reduxStoreName,
          reduxUid: this.reduxUid
        })
      );

      if (this.useExternalReduxStore) {
        return mainWrapper;
      }

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        mainWrapper
      );
    }
  }]);

  return MetisMenu;
}(_react2.default.Component);

MetisMenu.defaultProps = {
  content: [],
  ajax: null,
  LinkComponent: _DefaultLink2.default,
  noBuiltInClassNames: false,
  className: null,
  classNameContainer: null,
  classNameContainerVisible: null,
  classNameItem: null,
  classNameItemActive: null,
  classNameItemHasActiveChild: null,
  classNameItemHasVisibleChild: null,
  classNameLink: null,
  classNameLinkActive: null,
  classNameLinkHasActiveChild: null,
  classNameIcon: null,
  classNameStateIcon: null,
  iconNamePrefix: 'fa fa-',
  iconNameStateHidden: 'caret-left',
  iconNameStateVisible: 'caret-left rotate-minus-90',
  activeLinkId: null,
  activeLinkTo: null,
  activeLinkLabel: null,
  activeLinkFromLocation: false,
  onSelected: null,
  useExternalReduxStore: null,
  reduxStoreName: 'metisMenuStore'
};

MetisMenu.propTypes = {
  content: _propTypes2.default.arrayOf(_propTypes2.default.object),
  ajax: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),

  LinkComponent: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

  noBuiltInClassNames: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  classNameContainer: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  classNameContainerVisible: _propTypes2.default.string,
  classNameItem: _propTypes2.default.string,
  classNameItemActive: _propTypes2.default.string,
  classNameItemHasActiveChild: _propTypes2.default.string,
  classNameItemHasVisibleChild: _propTypes2.default.string,
  classNameLink: _propTypes2.default.string,
  classNameLinkActive: _propTypes2.default.string,
  classNameLinkHasActiveChild: _propTypes2.default.string,
  classNameIcon: _propTypes2.default.string,
  classNameStateIcon: _propTypes2.default.string,
  iconNamePrefix: _propTypes2.default.string,
  iconNameStateHidden: _propTypes2.default.string,
  iconNameStateVisible: _propTypes2.default.string,

  activeLinkId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  activeLinkTo: _propTypes2.default.string,
  activeLinkLabel: _propTypes2.default.string,
  activeLinkFromLocation: _propTypes2.default.bool,

  onSelected: _propTypes2.default.func,
  useExternalReduxStore: _propTypes2.default.object,
  reduxStoreName: _propTypes2.default.string
};

MetisMenu.childContextTypes = {
  classStore: _propTypes2.default.object.isRequired,
  LinkComponent: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]).isRequired
};

exports.default = MetisMenu;